import { useRef } from 'react';

import useAnimate from '@Hotels-at-Home/hah-fe-core/dist/hooks/useAnimate';
import HeroSection from './sections/HeroSection';
import PillowSection from './sections/PillowSection';
import CtaSection from './sections/CtaSection';
import DiscoverSection from './sections/DiscoverSection';
import MobileSection from './sections/MobileSection';
import { IGetPromotionResponse } from '@Hotels-at-Home/hah-fe-core/dist/types';

interface IProps {
  promotion: IGetPromotionResponse;
}

const Home = ({ promotion }: IProps) => {
  const animateRef = useRef(null);
  useAnimate(animateRef);

  return (
    <div id="home" ref={animateRef}>
      <HeroSection promotion={promotion} />
      <MobileSection />
      <PillowSection />
      <CtaSection />
      <DiscoverSection />
    </div>
  );
};

export default Home;
